/*
 * @Author: zhangwenbangde@163.com
 * @Date: 2019-04-18 16:45:53
 * */
import Vue from 'vue'
import VueRouter from 'vue-router'
import {routerMode} from '@/env'

Vue.use(VueRouter);

const routes = new VueRouter({
  mode: routerMode,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'layout',
      redirect:'/index',
      component: () => import('@/components/Layout.vue'),
      children:[
        {
          path: '/index',
          name: 'index',
          component: () => import('@/views/index/index.vue')
        },
        {
          path: '/article',
          name: 'article',
          component: () => import('@/views/article/index.vue')
        },
        {
          path: '/articleList',
          name: 'articleList',
          component: () => import('@/views/articleList/index.vue')
        },
        {
          path: '/tpic',
          name: 'tpic',
          component: () => import('@/views/tpic.vue')
        },
        {
          path: '/ygic',
          name: 'ygic',
          component: () => import('@/views/ygic.vue')
        },
        {
          path: '/gric',
          name: 'gric',
          component: () => import('@/views/gric.vue')
        }
      ]
    },
    {
      path: '/videoPage',
      name: 'videoPage',
      component: () => import('@/views/videoPage/index.vue')
    },
  ]
});

export default routes

